export default "__VITE_ASSET__D0F3nW78__"